import { Alert, Container, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';
import { RootState } from '../../store/store';
import InfoBox from '../ui/DaliaComponents';
import WizardStep from '../ui/WizardStep';
import './PatientInitWizardStep.css';

const PatientInitStepConfirmation: WizardStep = ({ formik }) => {
  const { patientEdited, error } = useSelector((state: RootState) => state.patients);
  return (
    <Container>
      {error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        <Grid container spacing={4}>
          <Grid size={12}>
            <InfoBox emoji="🚀">
              Le patient a été créé
              <br />
              Son identifiant : <strong>{patientEdited?.patientId}</strong>
              <br />
              Son code d'activation : <strong>{formik.values.code}</strong>
            </InfoBox>
          </Grid>
          <Grid size={12}>
            <Typography variant="body1">Nous avons envoyé au patient un email avec toutes les informations nécessaires pour commencer sa participation à l'étude.</Typography>
          </Grid>
          <Grid size={12}>
            <Typography variant="body1">Vous pouvez maintenant soit:</Typography>
            <Typography variant="body1" component="div">
              <ul>
                <li>
                  <strong>Compléter le questionnaire d'inclusion maintenant</strong> en cliquant sur le bouton ci-dessous (estimé environ 5 minutes).
                </li>
                <li>
                  <strong>Le compléter plus tard</strong>, vous le retrouverez dans la vue de fiche patient dans votre liste de patients.
                </li>
              </ul>
            </Typography>
          </Grid>
        </Grid>
      )}
    </Container>
  );
};
PatientInitStepConfirmation.label = 'Confirmation';

PatientInitStepConfirmation.initialValues = {};

PatientInitStepConfirmation.validationSchema = () => {
  return Yup.object({});
};

export default PatientInitStepConfirmation;